/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class CurativeAction {
    constructor(actionRequestId) {
        this.actionRequestId = actionRequestId;
        this.changedParts = [];
        this.attachments = [];
    }
}

export { CurativeAction };



// WEBPACK FOOTER //
// ./src/main/front/scripts/model/CurativeAction.js